/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "{3BF933FD-DB13-4BC7-87DA-CDED364F77B7}",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://mc-9c4845de-cb86-4d2c-8783-4342-cm.azurewebsites.net/",
config.jssAppName = process.env.REACT_APP_JSS_APP_NAME || "ABCD",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/items/web",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://mc-9c4845de-cb86-4d2c-8783-4342-cm.azurewebsites.net//sitecore/api/graph/items/web",
module.exports = config;